(function () {
  'use strict';

  if (window.DTRetentionGiftSync?.__loaded) return;

  const CAMPAIGN_ATTRIBUTE = '_dt_retention_campaign';
  const CAMPAIGN_VALUE = 'whatsapp_free_gifts_v1';
  const BUNDLE_PROPERTY = '_dt_retention_bundle';
  const GIFT_PROPERTY = '_dt_retention_gift';
  const ROOT = () => window.Shopify?.routes?.root || '/';

  function parseConfig() {
    const element = document.querySelector('[data-dt-retention-config]');
    if (!element || element.dataset.enabled !== 'true') return null;

    const gift = (threshold, worth) => {
      const tier = threshold / 100;
      return {
        enabled: element.getAttribute(`data-gift-${tier}-enabled`) === 'true',
        threshold,
        worth,
        variantId: Number(element.getAttribute(`data-gift-${tier}-id`) || 0),
        available: element.getAttribute(`data-gift-${tier}-available`) === 'true',
        title: element.getAttribute(`data-gift-${tier}-title`) || '',
        image: element.getAttribute(`data-gift-${tier}-image`) || ''
      };
    };

    const tiers = [
      gift(149900, 699),
      gift(249900, 999),
      gift(399900, 1499)
    ].filter((tier) => tier.enabled);

    return {
      eligibleProductIds: new Set(
        String(element.dataset.eligibleProductIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean)
      ),
      tiers
    };
  }

  function unlockedTier(total, config) {
    return config.tiers.reduce((active, tier) => total >= tier.threshold ? tier : active, null);
  }

  function itemProperty(item, name) {
    return String(item?.properties?.[name] || '').trim();
  }

  function retentionBundles(cart, config) {
    return (cart.items || []).reduce((bundles, item) => {
      const bundleId = itemProperty(item, BUNDLE_PROPERTY);
      if (!bundleId) return bundles;
      const bundle = bundles.get(bundleId) || { subtotal: 0, gifts: [] };
      if (itemProperty(item, GIFT_PROPERTY)) {
        bundle.gifts.push(item);
      } else if (config.eligibleProductIds.has(String(item.product_id))) {
        bundle.subtotal += Number(item.final_line_price || 0);
      }
      bundles.set(bundleId, bundle);
      return bundles;
    }, new Map());
  }

  async function cartRequest(path, body) {
    const execute = () => fetch(`${ROOT()}${path}`, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const withRetry = window.cartAddFetchWithRetry ? () => window.cartAddFetchWithRetry(execute) : execute;
    const response = window.cartMutationQueue && body
      ? await window.cartMutationQueue(withRetry)
      : await withRetry();
    if (!response.ok) throw new Error(`cart_${response.status}`);
    return response.json();
  }

  let reconciling = false;
  let queued = false;

  async function refreshCartUI() {
    if (window.CartController?.finishAddToCartRefresh) {
      await window.CartController.finishAddToCartRefresh({
        refreshRecommendations: false,
        refreshItems: true,
        refreshCartPage: Boolean(document.querySelector('#main-cart-items'))
      });
      return;
    }
    const cart = await cartRequest('cart.js');
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  async function reconcile(providedCart) {
    if (reconciling) {
      queued = true;
      return;
    }

    const config = parseConfig();
    if (!config) return;

    reconciling = true;
    try {
      const cart = providedCart?.items ? providedCart : await cartRequest('cart.js');
      if (cart.attributes?.[CAMPAIGN_ATTRIBUTE] !== CAMPAIGN_VALUE) return;

      const bundles = retentionBundles(cart, config);
      const updates = {};
      const giftsToAdd = [];

      bundles.forEach((bundle, bundleId) => {
        const desiredTier = unlockedTier(bundle.subtotal, config);
        let desiredGiftPresent = false;
        bundle.gifts.forEach((item) => {
          const isDesired = desiredTier && Number(item.variant_id) === desiredTier.variantId && !desiredGiftPresent;
          if (isDesired) {
            desiredGiftPresent = true;
            if (Number(item.quantity) !== 1) updates[item.key] = 1;
          } else {
            updates[item.key] = 0;
          }
        });
        if (desiredTier && !desiredGiftPresent && desiredTier.available && desiredTier.variantId) {
          giftsToAdd.push({
            id: desiredTier.variantId,
            quantity: 1,
            properties: {
              [BUNDLE_PROPERTY]: bundleId,
              [GIFT_PROPERTY]: String(desiredTier.threshold)
            }
          });
        }
      });

      const shouldClearCampaign = bundles.size === 0;
      const needsUpdate = Object.keys(updates).length > 0 || shouldClearCampaign;
      if (needsUpdate) {
        const body = { updates };
        if (shouldClearCampaign) body.attributes = { [CAMPAIGN_ATTRIBUTE]: '' };
        await cartRequest('cart/update.js', body);
      }

      if (giftsToAdd.length) {
        await cartRequest('cart/add.js', { items: giftsToAdd });
        await refreshCartUI();
      } else if (needsUpdate) {
        await refreshCartUI();
      }
    } catch (error) {
      console.warn('[Retention campaign] Unable to reconcile gift:', error);
    } finally {
      reconciling = false;
      if (queued) {
        queued = false;
        setTimeout(() => reconcile(), 80);
      }
    }
  }

  let timer;
  function schedule(event) {
    clearTimeout(timer);
    timer = setTimeout(() => reconcile(event?.detail), 120);
  }

  window.DTRetentionGiftSync = {
    __loaded: true,
    parseConfig,
    unlockedTier,
    reconcile,
    campaignAttribute: CAMPAIGN_ATTRIBUTE,
    campaignValue: CAMPAIGN_VALUE
  };

  document.addEventListener('cart:updated', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reconcile(), { once: true });
  } else {
    reconcile();
  }
})();
